import React, {FC} from 'react';

import QuestionCardRadio from '../../components/QuestionCardRadio';
import {FINANCIAL_DEPENDENTS_OPTIONS} from '../../constants';

const StepFinancialDependents: FC = () => (
  <QuestionCardRadio
    field="financialDependents"
    options={FINANCIAL_DEPENDENTS_OPTIONS}
  />
);

export default StepFinancialDependents;
